import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';

import { FiHome } from '@react-icons/all-files/fi/FiHome';
import { FiCreditCard } from '@react-icons/all-files/fi/FiCreditCard';
import { FiPieChart } from '@react-icons/all-files/fi/FiPieChart';
import { FiUser } from '@react-icons/all-files/fi/FiUser';
import { BiWallet } from '@react-icons/all-files/bi/BiWallet';
import { ROLE } from '@mais-retorno-front/constants/role';

type SubmenuItem = {
  label: string,
  icon: any,
  link: string,
  allowedRoles?: ROLE[]
}

export const APP_SUB_MENU: SubmenuItem[] = [
  {
    label: 'Ínicio',
    icon: <FiHome size={18} />,
    link: DEFAULT_ROUTES.dashboard,
  },
  {
    label: 'Comparações salvas',
    icon: <FiPieChart size={18} />,
    link: DEFAULT_ROUTES.bookmarkComparison,
  },
  {
    label: 'Gerenciador de carteiras',
    icon: <BiWallet size={18} />,
    link: DEFAULT_ROUTES.portfolio,
  },
  {
    label: 'Meu perfil',
    icon: <FiUser size={18} />,
    link: DEFAULT_ROUTES.userProfile,
  },
  {
    label: 'Assinaturas',
    icon: <FiCreditCard size={18} />,
    link: DEFAULT_ROUTES.userSubscription,
  },
];
